type Edition = { id?: string; countryISO2?: string; periodKey?: string; month: string };

export function observatoryEditionCountry(edition: Pick<Edition, 'id' | 'countryISO2'>): string | undefined {
  return edition.countryISO2 || edition.id?.match(/^\d{4}-country-([a-z]{2})-/)?.[1].toUpperCase();
}

export function observatoryEditionPath(edition: Edition): string {
  const country = observatoryEditionCountry(edition);
  return `/observatory/${country ? `${country.toLowerCase()}/` : ''}${edition.periodKey || edition.month}`;
}
